<template>
  <v-data-table-virtual
    :headers="shifts.header"
    :header-props="{ nowrap: true }"
    :items="shifts.body"
    item-key="period"
    hide-default-footer
    disable-pagination
    hover
    :fixed-header="true"
    class="elevation-1 shift-list"
  >
    <template #item="{item}">
      <tr class="text-no-wrap">
        <td class="first-column">
          {{ item.period }}
        </td>
        <td
          v-for="shift in item.shifts_by_period"
          :key="shift.id"
        >
          <slot
            name="cell"
            :shift="shift"
            :item="item"
          />
        </td>
      </tr>
    </template>
  </v-data-table-virtual>
</template>

<script>
export default {
  name: "ShiftTable",
  props: {
    shifts: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss">
.v-data-table.shift-list tbody td:first-child,
.v-data-table.shift-list tbody td:not(:first-child),
.v-data-table.shift-list tbody th:first-child,
.v-data-table.shift-list tbody th:not(:first-child),
.v-data-table.shift-list thead td:first-child,
.v-data-table.shift-list thead td:not(:first-child),
.v-data-table.shift-list thead th:first-child,
.v-data-table.shift-list thead th:not(:first-child) {
    padding: 0 24px;
}
.v-data-table.shift-list thead tr {
  height: 46px;
}
.v-data-table.shift-list th {
  font-size: 0.75rem;
}
.v-data-table.shift-list th:first-child,
.v-data-table.shift-list td:first-child {
  position: -webkit-sticky;
  position: sticky;
  left: 0;
  z-index: 1;
  background-color: white;
}

// ヘッダの一番左のセルを他のセルより前面に表示する
.v-data-table.shift-list thead th:first-child {
  z-index: 100 !important;
}

.v-data-table.shift-list tbody td {
    font-weight: 400;
    font-size: 13px;
}
</style>

<style scoped>
.shift-list {
    flex-grow: 1;
    overflow-y: auto;
}

.first-column {
  position: sticky !important;
  left: 0;
  background-color: white;
}
</style>
